export default __webpack_public_path__ + "static/media/features-1.8d2e5ed6.svg";